import { render, staticRenderFns } from "./CaseDashboardCard2.0.vue?vue&type=template&id=2e696064&scoped=true&"
import script from "./CaseDashboardCard2.0.vue?vue&type=script&lang=ts&"
export * from "./CaseDashboardCard2.0.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDashboardCard2.0.vue?vue&type=style&index=0&id=2e696064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e696064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
